import { UserTypes } from 'store/auth/types.ts'
import OverviewCard from 'pages/app/overview/overview-cards/OverviewCard.tsx'
import { selectIsEligibleForSalesSurvey, setShowSalesSurvey } from 'store/app/slice.ts'
import { useStoreDispatch, useStoreSelector } from 'hooks/store.ts'
import { useTranslation } from 'react-i18next'

const SalesSurveyOverviewCard = () => {
  // Redux
  const { userType } = useStoreSelector((state) => state.auth)
  const isEligibleForSalesSurvey = useStoreSelector(selectIsEligibleForSalesSurvey)
  const dispatch = useStoreDispatch()

  // i18n
  const { t } = useTranslation('overview')

  return (
    userType === UserTypes.CUSTOMER &&
    isEligibleForSalesSurvey && (
      <OverviewCard
        button={{
          label: t(($) => $.salesSurvey.action),
          onClick: () =>
            dispatch(
              setShowSalesSurvey({
                show: 'modal'
              })
            ),
          id: 'sales-survey'
        }}
        color="warm"
      >
        <OverviewCard.Title>{t(($) => $.salesSurvey.title)}</OverviewCard.Title>
        <p>{t(($) => $.salesSurvey.description)}</p>
      </OverviewCard>
    )
  )
}

export default SalesSurveyOverviewCard
